/**
 * Centralized display configuration schema for chart views.
 *
 * Defines every possible display option (icons, labels, overlays, etc.)
 * and their default values. Views declare which subset applies to them.
 *
 * Usage:
 *   const MY_OPTIONS = [DISPLAY_OPTION_KEYS.ICONS, DISPLAY_OPTION_KEYS.LABELS];
 *   const { displayConfig, setDisplayOption } = useChartDisplayConfig('myView', MY_OPTIONS);
 */

export const DISPLAY_OPTION_KEYS = {
  BAR_CHART:         'showBarChart',
  ICONS:             'showIcons',
  LABELS:            'showLabels',
  REGRESSION_LINE:   'showRegressionLine',
  CORRELATION_TABLE: 'showCorrelationTable',
  RULE40_LINE:       'showRule40Line',
  BACKGROUND_ZONES:  'showBackgroundZones',
};

export const DISPLAY_OPTION_DEFINITIONS = {
  showBarChart: {
    key: 'showBarChart',
    label: 'Chart Type',
    defaultValue: true,
    labelOn: 'BAR',
    labelOff: 'LINE',
  },
  showIcons: {
    key: 'showIcons',
    label: 'Company Icons',
    defaultValue: true,
    labelOn: 'ICONS',
    labelOff: 'NODES',
  },
  showLabels: {
    key: 'showLabels',
    label: 'Ticker Labels',
    defaultValue: false,
    labelOn: 'LABELS',
    labelOff: 'NONE',
  },
  showRegressionLine: {
    key: 'showRegressionLine',
    label: 'Trend Line (R\u00B2)',
    defaultValue: true,
    labelOn: 'SHOW',
    labelOff: 'HIDE',
  },
  showCorrelationTable: {
    key: 'showCorrelationTable',
    label: 'Correlation Table',
    defaultValue: true,
    labelOn: 'SHOW',
    labelOff: 'HIDE',
  },
  showRule40Line: {
    key: 'showRule40Line',
    label: 'Rule of 40 Line',
    defaultValue: true,
    labelOn: 'SHOW',
    labelOff: 'HIDE',
  },
  showBackgroundZones: {
    key: 'showBackgroundZones',
    label: 'Zone Shading',
    defaultValue: true,
    labelOn: 'SHADED',
    labelOff: 'NONE',
  },
};

export const DISPLAY_CONFIG_STORAGE_PREFIX = 'chartDisplay_';
